import React from "react";
import {Input} from "antd";
import {SplitInputWrapperProps, InputWrapper} from "../../functions";
import {TextAreaBoxProps} from "./interface";
import {validations} from "../../../../config/validations/validations";
import {toLowerCaseWithUnderscore} from "../../../AgGridWrapper/utils/commonFunctions";
const {TextArea} = Input;

const TextAreaInputBox: React.FC<TextAreaBoxProps> = ({rows = 4, ...rest}) => {
    const {
        formProps: {rules = [], ...formProps},
        inputProps,
    } = SplitInputWrapperProps(rest);

    if (formProps?.required) {
        rules.filter((rule: any) => rule.required).length === 0 &&
            rules.push(validations.required.text());
    }

    return (
        <InputWrapper
            name={formProps?.label && toLowerCaseWithUnderscore(formProps?.label)}
            rules={rules}
            {...formProps}
        >
            <TextArea placeholder={formProps?.label} {...inputProps} rows={rows} />
        </InputWrapper>
    );
};

export default TextAreaInputBox;
